import React, { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Modal, Form, Row, Col, Input, Select } from "antd";
import { eContent } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { DatePicker } from "antd";
import moment from "moment";

export const EditDetailModal: React.FC<{
  dataSource: any;
  setDataSource: any;
  index: any;
}> = ({ dataSource, setDataSource, index }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    dataSource[index].productLifetime = moment(
      dataSource[index].productLifetime
    );
    form.setFieldsValue(dataSource[index]);

    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const test = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = [...dataSource];
    newDataSource[index] = values;

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal}>
        <EditOutlined rev="data" />
      </Button>

      <Modal
        title="Thông tin đề nghị xuất kho"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <Col span={24}>
              <StyledTitle level={5}>Tên vật tư/ hàng hóa</StyledTitle>
              <Form.Item
                name={eContent.productName}
                rules={[
                  { required: true, message: "Nhập tên vật tư/ hàng hóa *" },
                ]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>ĐVT</StyledTitle>
              <Form.Item
                name={eContent.Dram}
                rules={[{ required: true, message: "Nhập ĐVT" }]}
              >
                <Select
                  options={[
                    {
                      value: "Cái",
                      label: "Cái",
                    },
                  ]}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <StyledTitle level={5}>Số lượng đề nghị</StyledTitle>
              <Form.Item
                name={eContent.requestedQuantity}
                rules={[
                  { required: true, message: "Nhập Số lượng đề nghị" },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <StyledTitle level={5}>Số lượng tồn tại đơn vị</StyledTitle>
              <Form.Item
                name={eContent.inventoryQuantity}
                rules={[
                  {
                    required: true,
                    message: "Nhập Số lượng tồn tại đơn vị",
                  },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>Thời gian sử dụng</StyledTitle>
              <Form.Item name={eContent.productLifetime}>
                <DatePicker disabled={true} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>Ghi chú</StyledTitle>
              <Form.Item name={eContent.note}>
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>Số lượng phê duyệt</StyledTitle>
              <Form.Item
                name={eContent.approvedQuantity}
                rules={[
                  {
                    required: true,
                    message: "Nhập Số lượng phê duyệt",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
